import { constants } from 'aliases';

export enum PageId {
  UNKNOWN = 'Unknown',
  ERROR = 'Error',
  SPLASH = 'Splash',
  SEARCH = 'Browse',
  CONTINUE = 'Continue',
  EPG = 'Channels',
  SETTINGS = 'Settings',
  MOVIE_DETAIL = 'Movie Detail',
  SERIES_DETAIL = 'Series Detail',
  LIVE_EVENT_DETAIL = 'Live Event Detail',
  CONTENT_HUB = 'Content Hub',
  HOME = 'Home',
  PLAYBACK = 'Playback',
  MY_STUFF = 'My Stuff', // report via getPageId
  FAVORITE_CHANNELS = 'Favorite Channels',
  INITIAL_LANDING_PAGE = 'Initial Landing Page',
  LOGIN = 'Login',
  CONTINUE_WATCHING = 'Continue Watching',
  WATCHLIST = 'Watchlist',
}

export const getPageId = (pageId: PageId | string): string =>
  pageId === PageId.MY_STUFF ? constants.brandTokens.myStuffPageId : pageId;
